<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title> Access-A-Ride Assessments </v-toolbar-title>
      <v-spacer></v-spacer>
      <upload-assessment-button
        v-if="isOmniUser"
        @uploadAssessments="uploadAssessments"
      ></upload-assessment-button>
    </v-toolbar>
    <v-row>
      <v-col cols="12" sm="5">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field> </v-col
          ><v-col cols="12" sm="4">
            <download-zip-button
              :selectedFiles="selectedItems.map((item) => item.fileId)"
              :zipFileName="zipFileName"
              @clear="clearSelected"
            ></download-zip-button
          ></v-col>
        </v-row>
        <v-data-table
          v-model="selectedItems"
          :headers="headers"
          :items="assessments"
          item-key="aarAssessmentId"
          :search="search"
          :items-per-page="15"
          group-by="groupHeader"
          group-desc
          @click:row="loadFile"
          show-select
          dense
          height="100%"
          style="cursor: pointer"
          :item-class="highlightSelectedRow"
          :key="assessments.length"
        >
          <template v-slot:[`header.data-table-select`]></template>
          <template
            v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
            ><td :colspan="headers.length">
              <v-btn @click="toggle" x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-minus</v-icon>
                <v-icon v-else>mdi-plus</v-icon>
              </v-btn>
              <span class="mx-5 font-weight-bold text-subtitle-2">
                {{ items[0].formattedDateOfService }} -
                {{ items[0].aarLocation }}
              </span>
            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <edit-assessment
              v-if="isOmniUser"
              :assessment="item"
            ></edit-assessment>
            <delete-assessment
              v-if="isAdmin"
              :aarAssessmentId="item.aarAssessmentId"
            ></delete-assessment>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" sm="7">
        <file-viewer :noFiles="noFiles" ref="fileViewerRef"></file-viewer>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DownloadZipButton from "../Shared/download-zip-button";
import EditAssessment from "./edit-assessment";
import DeleteAssessment from "./delete-assessment";
import UploadAssessmentButton from "./upload-assessment-button.vue";
import FileViewer from "../Shared/file-viewer.vue";

export default {
  components: {
    DownloadZipButton,
    UploadAssessmentButton,
    EditAssessment,
    DeleteAssessment,
    FileViewer,
  },
  data() {
    return {
      headers: [
        {
          text: "Filename",
          value: "file.fileName",
        },
        {
          text: "Date",
          value: "formattedDateOfService",
          align: " d-none",
        },
        {
          text: "Location",
          value: "aarLocation",
          align: " d-none",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      search: "",
      selected: null,
      selectedItems: [],
    };
  },
  async mounted() {
    this.$store.commit("uxModule/setShowLoader", true);
    if (this.isOmniUser) {
      await this.$store.dispatch("assessmentsModule/getAARAssessments");
    } else {
      var today = new Date();
      var sixtyDaysAgo = new Date(today);
      sixtyDaysAgo.setDate(today.getDate() - 60);
      await this.$store.dispatch(
        "assessmentsModule/getAARAssessments",
        sixtyDaysAgo
      );
    }
    this.$store.commit("uxModule/setShowLoader", false);
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    isOmniUser() {
      return this.$store.getters["securityModule/isOmniUser"];
    },
    assessments() {
      return this.$store.state.assessmentsModule.assessments;
    },
    noFiles() {
      return this.assessments.length === 0;
    },
    zipFileName: function () {
      return "AARAssessments.zip";
    },
  },
  methods: {
    async loadFile(item) {
      this.selected = item;
      this.$refs.fileViewerRef.loadFile(item.file);
    },
    highlightSelectedRow: function (row) {
      return (
        this.selected?.aarAssessmentId === row.aarAssessmentId && "selectedRow"
      );
    },
    clearSelected() {
      this.selectedItems = [];
    },

    // this calls a callback when done
    uploadAssessments: async function (date, location, value, done) {
      await this.$store.dispatch("assessmentsModule/uploadAssessments", {
        dateOfService: date,
        aarLocation: location,
        files: value,
      });

      done();
    },
  },
};
</script>

<style lang="css">
.selectedRow {
  background: #ccc;
}
</style>
